import dayjs from 'dayjs';
export function getCurrentDate() {
  const date = new Date();
  let day = ("0" + date.getDate()).slice(-2);
  let month = ("0" + (date.getMonth() + 1)).slice(-2);
  let year = date.getFullYear();
  let currentDate = year + "-" + month + "-" + day;
  return currentDate;
}

export function getCurrentDateTextFormat() { 
  let today = new Date();
  let days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  let day = days[today.getDay()];
  let month = today.toLocaleString('default', { month: 'short' });
  let date = today.getDate();
  let year = today.getFullYear();
  return `${day}, ${month} ${date} ${year}`;
}


export function formatDateTime(zuluDateTime: string | null | undefined) {
  if (!zuluDateTime) {
      return "";
  }

  const date = new Date(zuluDateTime ?? "");
  let hours = date.getUTCHours().toString();
  let minutes = date.getUTCMinutes().toString();

  hours = hours.length < 2 ? `0${hours}` : hours;
  minutes = minutes.length < 2 ? `0${minutes}` : minutes;

  const formattedTime = `${hours}:${minutes}`;

  return formattedTime;
}

export const getDatetimeUtcNowString = (format = "YYYY-MM-DD HH:mm:ss") => {
    // validate input parameter
    if (format == null) {
        return null;
    }

    return dayjs.utc().format(format);
}